import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';
import { NgxMatNativeDateAdapter } from '@angular-material-components/datetime-picker';

const shouldUseCustomFormatting = (displayFormat: any): boolean => {
  return (
    displayFormat.year === 'numeric' &&
    displayFormat.month === 'numeric' &&
    displayFormat.day === 'numeric'
  );
};
@Injectable()
export class MatCustomDateAdapter extends NativeDateAdapter {
  dateFormatter: (date: Date) => string;
  format(date: Date, displayFormat: object): string {
    if (this.dateFormatter && shouldUseCustomFormatting(displayFormat)) {
      return this.dateFormatter(date);
    }
    return super.format(date, displayFormat);
  }
}

@Injectable()
export class NgxMatCustomDateAdapter extends NgxMatNativeDateAdapter {
  dateFormatter: (date: Date) => string;
  dateTimeFormatter: (date: Date) => string;
  format(date: Date, displayFormat: object): string {
    if (
      this.dateFormatter &&
      this.dateTimeFormatter &&
      shouldUseCustomFormatting(displayFormat)
    ) {
      if (date.getHours() === 0 && date.getMinutes() === 0) {
        return this.dateFormatter(date);
      }
      return this.dateTimeFormatter(date);
    }
    return super.format(date, displayFormat);
  }
  getFirstDayOfWeek(): number {
    return 1;
  }
}
